import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LegalCenterService } from '@app/services/api/legal-center.service';
import { FooterService } from '@app/services/footer.service';
import { SettingsService } from '@app/services/settings.service';
import { LegalDocumentModel, SocialLink } from 'library-explorer';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BasicPage } from 'src/app/model/basic-page.model';
import { SocialType } from 'src/app/model/enums/social-type.enum';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterComponent implements OnInit, OnDestroy {
  @Input() showLanguageSwitcher = false;
  @Input() public set isLoggedIn(value: boolean) {
    if (value !== undefined) {
      this.getMenuItems();
    }
  }
  public socialLinks: SocialLink[];
  public email: string;
  public menu: BasicPage[] = [];
  public documents: LegalDocumentModel[] = [];

  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private readonly dialog: MatDialog,
    private readonly legalCenterService: LegalCenterService,
    private readonly settingsService: SettingsService,
    private readonly footerService: FooterService
  ) { }

  public readonly socialType: typeof SocialType = SocialType;

  ngOnInit() {
    this.loadlLegalDocuments();

    this.settingsService.getSettings()
      .pipe(
        takeUntil(this.unsubscribe)
      )
      .subscribe(data => {
        this.socialLinks = data.socialLink;
        this.email = data.general.email;
      });
  }

  private getMenuItems(): void {
    this.menu = [];
    this.footerService.getMenu().pipe(
      takeUntil(this.unsubscribe)
    ).subscribe(res => {
      this.menu = res.items;
    });
  }

  private loadlLegalDocuments(): void {
    this.legalCenterService.getDocuments({ showInFooter: 1 })
      .subscribe(data => {
        this.documents = data.items;
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
